import { ReactNode } from 'react';
import { Title } from '@components';
import { useEditMode } from '@hooks';
import { Box, BoxProps, Container, Typography } from '@mui/material';

export type ContentAreaEditorProps = BoxProps & {
  property: string;
  name?: string;
  children?: ReactNode;
};

export const ContentAreaEditor = ({
  property,
  name = 'Edit Content Area',
}: ContentAreaEditorProps) => {
  const { inEditMode } = useEditMode();
  return inEditMode ? (
    <Container
      component='div'
      sx={{ width: '100%', height: 32, p: 2, pb: 8, mb: 8, cursor: 'pointer' }}
    >
      <Box data-epi-edit={property} sx={{ mb: 4, mx: 'auto' }}>
        <Title variant='h2' sx={{ mb: 2 }} regular>
          {name}
        </Title>
        <Typography>Click here to edit this Content Area</Typography>
      </Box>
    </Container>
  ) : null;
};
